import { useState, useEffect } from "react";
import { useGetSubcontractorDetails } from "./useSubcontractors";

export function useFetchSubcontractorDetails(place_id) {
  const [detailsRequest, setDetailsRequest] = useState(null);

  useEffect(() => {
    if (place_id) {
      setDetailsRequest({ place_id });
    } else {
      setDetailsRequest(null);
    }
  }, [place_id]);

  const queryResult = useGetSubcontractorDetails(detailsRequest);

  return queryResult;
}